import React from "react";
import {
  Modal,
  Dropdown,
  TextInput,
  FormGroup,
  Grid,
  Column,
  InlineLoading
} from "@carbon/react";

export default function EditContactModal({
  isEditContactModalOpen,
  setIsEditContactModalOpen,
  editingProperty,
  editContactForm,
  dropdownOptions,
  savingContact,
  handleEditContactChange,
  handleUpdateContact,
  findSelectedItem,
  requiredLabel,
  validateNumericInput
}) {

  return (
    <Modal
      open={isEditContactModalOpen}
      modalHeading={`Edit Contact - ${editingProperty?.propertyTitle || "Property"}`}
      primaryButtonText={savingContact ? "Updating..." : "Update Contact"}
      secondaryButtonText="Cancel"
      onRequestClose={() => setIsEditContactModalOpen(false)}
      onRequestSubmit={handleUpdateContact}
      primaryButtonDisabled={savingContact}
    >
      {editingProperty && (
        <FormGroup legendText={<strong>Contact Information</strong>}>
          <Grid narrow>

            <Column lg={6} md={4} sm={4}>
              <Dropdown
                id="edit-postingBy"
                titleText={requiredLabel("Posting By")}
                label="Select"
                items={dropdownOptions.postingBy}
                itemToString={(item) => item?.text || ""}
                onChange={({ selectedItem }) =>
                  handleEditContactChange("postingBy", selectedItem?.text || "")
                }
                selectedItem={findSelectedItem(
                  dropdownOptions.postingBy,
                  editContactForm.postingBy
                )}
              />
            </Column>

            <Column lg={6} md={4} sm={4}>
              <Dropdown
                id="edit-contactPerson"
                titleText="Contact Person"
                label="Select"
                items={dropdownOptions.contactPerson}
                itemToString={(item) => item?.text || ""}
                onChange={({ selectedItem }) =>
                  handleEditContactChange("contactPerson", selectedItem?.text || "")
                }
                selectedItem={findSelectedItem(
                  dropdownOptions.contactPerson,
                  editContactForm.contactPerson
                )}
              />
            </Column>

          </Grid>

          <Grid narrow style={{ marginTop: 16 }}>

            {/* Contact Person */}
            <Column lg={6} md={4} sm={4}>
              <Dropdown
                id="edit-contactPersonNumber"
                titleText="Contact Person Number?"
                label="Select"
                items={dropdownOptions.contactPersonNumber}
                itemToString={(item) => item?.text || ""}
                onChange={({ selectedItem }) =>
                  handleEditContactChange("contactPersonNumber", selectedItem?.text || "")
                }
                selectedItem={findSelectedItem(
                  dropdownOptions.contactPersonNumber,
                  editContactForm.contactPersonNumber
                )}
              />

              {editContactForm.contactPersonNumber === "Yes" && (
                <TextInput
                  id="edit-contactPersonContact"
                  labelText={requiredLabel("Contact Number")}
                  value={editContactForm.contactPersonContact}
                  onChange={(e) =>
                    handleEditContactChange(
                      "contactPersonContact",
                      validateNumericInput(e.target.value)
                    )
                  }
                  placeholder="+91"
                  inputMode="numeric"
                  style={{ marginTop: 8 }}
                />
              )}
            </Column>

          </Grid>

          {savingContact && (
            <div style={{ marginTop: 16 }}>
              <InlineLoading description="Updating contact information..." />
            </div>
          )}
        </FormGroup>
      )}
    </Modal>
  );
}